var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.25 19.989999",
    xmlSpace: "preserve",
    width: 22.25,
    height: 19.99,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.Ombra_x0020_esterna{fill:none;}\n\t.Angoli_x0020_arrotondati_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Riflessione_x0020_X_x0020_dinamica{fill:none;}\n\t.Smusso_x0020_morbido{fill:url(#SVGID_1_);}\n\t.Crepuscolo{fill:#FFFFFF;}\n\t.Fogliame_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51AEE2;}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0.70709997,
    y2: 0.70709997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    },
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    style: {
      stopColor: "#E2E2E6"
    },
    id: "stop8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5D4D8"
    },
    id: "stop10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5323,
    style: {
      stopColor: "#C0BFC2"
    },
    id: "stop12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#A4A2A4"
    },
    id: "stop14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#828282"
    },
    id: "stop16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    },
    id: "stop18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    transform: "translate(-637.48,-413.15)",
    style: {
      fill: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    d: "m 658.1,413.15 h -18.99 c -0.9,0 -1.63,0.73 -1.63,1.63 v 13.69 c 0,0.9 0.73,1.63 1.63,1.63 h 6.63 l -0.39,1.37 c -0.2,0.58 -0.73,0.99 -1.35,1.02 h -2.13 c -0.18,0 -0.33,0.14 -0.33,0.32 0,0.18 0.14,0.33 0.32,0.33 0,0 0,0 0,0 h 13.47 c 0.18,0 0.33,-0.14 0.33,-0.32 0,-0.18 -0.14,-0.33 -0.32,-0.33 0,0 0,0 0,0 h -2.13 c -0.62,-0.03 -1.15,-0.43 -1.35,-1.02 l -0.39,-1.37 h 6.63 c 0.9,0 1.63,-0.73 1.63,-1.63 v -13.69 c 0,-0.89 -0.73,-1.62 -1.63,-1.63 z m -6.87,18.5 c 0.09,0.32 0.27,0.6 0.5,0.84 h -6.26 c 0.23,-0.23 0.41,-0.52 0.5,-0.84 l 0.44,-1.55 h 4.38 z m 7.85,-3.17 c 0,0.54 -0.44,0.98 -0.98,0.98 h -18.99 c -0.54,0 -0.98,-0.44 -0.98,-0.98 v -13.69 c 0,-0.54 0.44,-0.98 0.98,-0.98 h 18.99 c 0.54,0 0.98,0.44 0.98,0.98 z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    d: "m 658.43,427.17 v -12.39 c 0,-0.18 -0.15,-0.33 -0.33,-0.33 h -18.99 c -0.18,0 -0.33,0.15 -0.33,0.33 0,0 0,0 0,0 v 5.54 c 0,0.18 0.15,0.33 0.33,0.32 0.18,0 0.32,-0.15 0.32,-0.32 v -5.21 h 18.34 v 11.74 h -18.34 v -5.21 c 0,-0.18 -0.15,-0.33 -0.33,-0.32 -0.18,0 -0.32,0.15 -0.32,0.32 v 5.54 c 0,0.18 0.15,0.33 0.33,0.33 0,0 0,0 0,0 h 18.99 c 0.18,-0.02 0.33,-0.16 0.33,-0.34 z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    d: "m 658.46,428.47 c 0,0.18 -0.15,0.33 -0.33,0.33 -0.18,0 -0.33,-0.15 -0.33,-0.33 0,-0.18 0.15,-0.33 0.33,-0.33 v 0 c 0.18,0.01 0.33,0.15 0.33,0.33 z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    d: "m 657.15,428.47 c 0,0.18 -0.15,0.33 -0.33,0.33 -0.18,0 -0.33,-0.15 -0.33,-0.33 0,-0.18 0.15,-0.33 0.33,-0.33 v 0 c 0.19,0.01 0.33,0.15 0.33,0.33 z",
    style: {
      fill: "#ffffff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.75e90406a4f758358e92351f11bbf7d7.svg";
export { ForwardRef as ReactComponent };